const svgAssetMap = new Map();

const BUILTIN_COLOR_SCHEMES = {
    primary: {
        Dark: {
            textColor: '#fff',
            color: '#292929',
            hoverColor: '#7979FC',
            hoverTextColor: '#fff',
            selectedColor: '#3636E3',
            selectedTextColor: '#fff',
            disabledColor: '#1B1B1B',
            disabledTextColor: '#1D1D1D',
            pressedColor: '#414141',
            pressedTextColor: '#fff'
        },
        Light: {
            textColor: '#111111',
            color: '#E8E8E8',
            hoverColor: '#7979FC',
            hoverTextColor: '#fff',
            selectedColor: '#3636E3',
            selectedTextColor: '#fff',
            disabledColor: '#F4F4F4',
            disabledTextColor: '#B0B0B0',
            pressedColor: '#D2D2D2',
            pressedTextColor: '#111111'
        }
    },
    accent: {
        Dark: {
            textColor: '#fff',
            color: '#3636E3',
            hoverColor: '#1F1F76',
            hoverTextColor: '#fff',
            selectedColor: '#7979FC',
            selectedTextColor: '#fff',
            disabledColor: '#202065',
            disabledTextColor: '#575757',
            pressedColor: '#171759',
            pressedTextColor: '#fff'
        },
        Light: {
            textColor: '#fff',
            color: '#3636E3',
            hoverColor: '#1F1F76',
            hoverTextColor: '#fff',
            selectedColor: '#7979FC',
            selectedTextColor: '#fff',
            disabledColor: '#3636E366',
            disabledTextColor: '#B0B0B0',
            pressedColor: '#171759',
            pressedTextColor: '#fff'
        }
    },
    cta: {
        Dark: {
            textColor: '#111111',
            color: '#FAFAFA',
            hoverColor: '#7979FC',
            hoverTextColor: '#fff',
            selectedColor: '#3636E3',
            selectedTextColor: '#fff',
            disabledColor: '#6E6E6E',
            disabledTextColor: '#B0B0B0',
            pressedColor: '#5959D9',
            pressedTextColor: '#fff'
        },
        Light: {
            textColor: '#fff',
            color: '#252538',
            hoverColor: '#7979FC',
            hoverTextColor: '#fff',
            selectedColor: '#5500DF',
            selectedTextColor: '#fff',
            disabledColor: '#A8A6AF',
            disabledTextColor: '#1B1B1B',
            pressedColor: '#5959D9',
            pressedTextColor: '#fff'
        }
    },
    dropdown: {
        Dark: {
            textColor: '#fff',
            color: '#292929',
            hoverColor: '#7979FC',
            hoverTextColor: '#fff',
            selectedColor: '#3636E3',
            selectedTextColor: '#fff',
            disabledColor: '#1D1D1D',
            disabledTextColor: '#575757',
            pressedColor: '#5959D9',
            pressedTextColor: '#fff'
        },
        Light: {
            textColor: '#111111',
            color: '#E8E8E8',
            hoverColor: '#7979FC',
            hoverTextColor: '#fff',
            selectedColor: '#3636E3',
            selectedTextColor: '#fff',
            disabledColor: '#F4F4F4',
            disabledTextColor: '#B0B0B0',
            pressedColor: '#5959D9',
            pressedTextColor: '#fff'
        }
    },
    tertiary: {
        Dark: {
            textColor: '#fff',
            color: '#161616',
            hoverColor: '#303058',
            hoverTextColor: '#fff',
            selectedColor: '#4B4B4B',
            selectedTextColor: '#fff',
            disabledColor: '#141414',
            disabledTextColor: '#575757',
            pressedColor: '#1D1D1D',
            pressedTextColor: '#fff'
        },
        Light: {
            textColor: '#111111',
            color: '#FBFBFB',
            hoverColor: '#D7D7FE',
            hoverTextColor: '#111111',
            selectedColor: '#D2D2D2',
            selectedTextColor: '#111111',
            disabledColor: '#FDFDFD',
            disabledTextColor: '#B6B6B6',
            pressedColor: '#F4F4F4',
            pressedTextColor: '#111111'
        }
    },
    destructiveRed: {
        Dark: {
            textColor: '#fff',
            color: '#FB2F2F',
            hoverColor: '#781717',
            hoverTextColor: '#fff',
            selectedColor: '',
            selectedTextColor: '',
            disabledColor: '#852020',
            disabledTextColor: '#575757',
            pressedColor: '#561010',
            pressedTextColor: '#fff'
        },
        Light: {
            textColor: '#fff',
            color: '#FB2F2F',
            hoverColor: '#781717',
            hoverTextColor: '#fff',
            selectedColor: '',
            selectedTextColor: '',
            disabledColor: '#FC6363',
            disabledTextColor: '#B6B6B6',
            pressedColor: '#561010',
            pressedTextColor: '#fff'
        }
    },
    destructive: {
        Dark: {
            textColor: '#FB2F2F',
            color: '#1D1D1D',
            hoverColor: '#414141',
            hoverTextColor: '#FB2F2F',
            selectedColor: '',
            selectedTextColor: '',
            disabledColor: '#1D1D1D',
            disabledTextColor: '#575757',
            pressedColor: '#343434',
            pressedTextColor: '#FB2F2F'
        },
        Light: {
            textColor: '#FB2F2F',
            color: '#E8E8E8',
            hoverColor: '#7979FC',
            hoverTextColor: '#FB2F2F',
            selectedColor: '',
            selectedTextColor: '',
            disabledColor: '#F4F4F4',
            disabledTextColor: '#B0B0B0',
            pressedColor: '#D2D2D2',
            pressedTextColor: '#FB2F2F'
        }
    }
};

const COLOR_SCHEME_KEYS = [
    'textColor',
    'color',
    'hoverColor',
    'hoverTextColor',
    'selectedColor',
    'selectedTextColor',
    'disabledColor',
    'disabledTextColor',
    'pressedColor',
    'pressedTextColor',
    'opacity'
];

const COLOR_SCHEME_ALIASES = {
    tetriary: 'tertiary'
};

function normalizeColorSchemeKey(value) {
    if (typeof value !== 'string') {
        return 'primary';
    }

    const key = value.trim().toLowerCase();
    if (!key) {
        return 'primary';
    }

    return COLOR_SCHEME_ALIASES[key] || key;
}

AFRAME.registerPrimitive('ui-button', {
    defaultComponents: {
        'ui-button': {}
    },
    mappings: {
        label: 'ui-button.label',
        image: 'ui-button.image',
        type: 'ui-button.type',
        width: 'ui-button.width',
        height: 'ui-button.height',
        depth: 'ui-button.depth',
        radius: 'ui-button.radius',
        cornerstyle: 'ui-button.cornerstyle',
        autosize: 'ui-button.autosize',
        'is-selectable': 'ui-button.isSelectable',
        selected: 'ui-button.selected',
        disabled: 'ui-button.disabled',
        'color-scheme': 'ui-button.colorScheme',
        'preferred-font-size': 'ui-button.preferredFontSize'
    }
});

AFRAME.registerComponent('ui-button', {
    schema: {
        label: { type: 'string', default: '' },
        image: { type: 'string', default: '' },
        type: { type: 'string', default: 'plane', oneOf: ['plane', 'box', 'rounded-box', 'image-text'] },
        width: { type: 'number', default: 1 },
        height: { type: 'number', default: 0.5 },
        depth: { type: 'number', default: 0.1 },
        radius: { type: 'number', default: 0.05 },
        cornerstyle: { type: 'string', default: 'ext', oneOf: ['ext', '3d'] },
        autosize: { type: 'boolean', default: false },
        isSelectable: { type: 'boolean', default: false },
        selected: { type: 'boolean', default: false },
        disabled: { type: 'boolean', default: false },
        preferredFontSize: { type: 'number' },
        hoverAble: { type: 'boolean', default: true },
        textZp: { type: 'number' },
        contentRotation: { type: 'number' },
        isAutoRotationContent: { type: 'boolean', default: false },
        hoverScale: { type: 'number', default: 1.1 },
        clickScale: { type: 'number', default: 0.95 },
        colorScheme: {
            default: 'primary',
            parse: function (value) {
                if (value && typeof value === 'object') {
                    return value;
                }

                if (typeof value !== 'string') {
                    return 'primary';
                }

                const trimmed = value.trim();
                if (!trimmed) {
                    return 'primary';
                }

                const normalized = normalizeColorSchemeKey(trimmed);
                if (BUILTIN_COLOR_SCHEMES[normalized]) {
                    return normalized;
                }

                if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
                    try {
                        const parsed = JSON.parse(trimmed);
                        if (parsed && typeof parsed === 'object') {
                            return parsed;
                        }
                    } catch (e) {
                        return 'primary';
                    }
                }

                return 'primary';
            },
            stringify: function (value) {
                if (value && typeof value === 'object') {
                    return JSON.stringify(value);
                }
                return String(value || 'primary');
            }
        }
    },

    init: function () {
        this.activeThemeMode = 'Dark';
        this.currentThemeColors = null;
        this.currentVisualState = 'default';
        this.currentContentColor = null;
        this.isHovered = false;
        this.isPressed = false;

        this.onThemeChanged = this.onThemeChanged.bind(this);
        this.el.sceneEl.addEventListener('theme-changed', this.onThemeChanged);

        this.loadThemeFromCache();
        this.currentThemeColors = this.resolveThemeColors(this.activeThemeMode);
        this.baseColor = new THREE.Color(this.currentThemeColors.color);
        this.currentHoverColor = new THREE.Color(this.currentThemeColors.hoverColor);
        this.currentClickColor = new THREE.Color(this.currentThemeColors.pressedColor);

        this.createButton();

        const s = this.el.getAttribute('scale') || { x: 1, y: 1, z: 1 };
        this.initialScale = { x: s.x, y: s.y, z: s.z };

        this.bindEvents();
        this.updateThemeAppearance(this.activeThemeMode);
    },

    loadThemeFromCache: function () {
        if (typeof getCacheItem === 'function') {
            const mainSettings = getCacheItem('mainSettings');
            if (mainSettings && (mainSettings.themeMode === 'Light' || mainSettings.themeMode === 'Dark')) {
                this.activeThemeMode = mainSettings.themeMode;
            } else {
                const settings = getCacheItem('configureControlSettings');
                if (settings && settings.themeMode) {
                    this.activeThemeMode = settings.themeMode;
                }
            }
        }
    },

    initializeThemeState: function () {
        if (typeof getCacheItem === 'function') {
            const mainSettings = getCacheItem('mainSettings');
            if (mainSettings && (mainSettings.themeMode === 'Light' || mainSettings.themeMode === 'Dark')) {
                this.updateThemeAppearance(mainSettings.themeMode);
            } else {
                const settings = getCacheItem('configureControlSettings');
                if (settings && settings.themeMode) {
                    this.updateThemeAppearance(settings.themeMode);
                }
            }
        }
    },

    sanitizeColorSchemeObject: function (schemeObject, fallback) {
        const safe = Object.assign({}, fallback);
        if (!schemeObject || typeof schemeObject !== 'object') {
            return safe;
        }

        for (let i = 0; i < COLOR_SCHEME_KEYS.length; i += 1) {
            const key = COLOR_SCHEME_KEYS[i];
            const value = schemeObject[key];
            if (key === 'opacity') {
                if (typeof value === 'number' && value >= 0 && value <= 1) {
                    safe.opacity = value;
                }
            } else if (typeof value === 'string' && value.trim()) {
                safe[key] = value;
            }
        }

        return safe;
    },

    resolveThemeColors: function (themeMode) {
        const mode = themeMode === 'Light' ? 'Light' : 'Dark';
        const fallback = Object.assign({ opacity: 1 }, BUILTIN_COLOR_SCHEMES.primary[mode]);
        const schemeValue = this.data.colorScheme;

        if (typeof schemeValue === 'string') {
            const name = normalizeColorSchemeKey(schemeValue);
            const preset = BUILTIN_COLOR_SCHEMES[name] || BUILTIN_COLOR_SCHEMES.primary;
            return Object.assign({ opacity: 1 }, preset[mode]);
        }

        if (schemeValue && typeof schemeValue === 'object') {
            const modeObject = schemeValue[mode] || schemeValue[mode.toLowerCase()];
            if (modeObject && typeof modeObject === 'object') {
                return this.sanitizeColorSchemeObject(modeObject, fallback);
            }
            return this.sanitizeColorSchemeObject(schemeValue, fallback);
        }

        return fallback;
    },

    getBaseStateName: function () {
        if (this.data.disabled) {
            return 'disabled';
        }
        if (this.data.selected) {
            return 'selected';
        }
        return 'default';
    },

    getEffectiveStateName: function (transientState) {
        const baseState = this.getBaseStateName();
        if (baseState !== 'default') {
            return baseState;
        }
        if (transientState === 'hover' || transientState === 'pressed') {
            return transientState;
        }
        return 'default';
    },

    getVisualForState: function (stateName) {
        const palette = this.currentThemeColors || this.resolveThemeColors(this.activeThemeMode);
        const opacity = typeof palette.opacity === 'number' ? palette.opacity : 1;

        if (stateName === 'hover') {
            return { color: palette.hoverColor, textColor: palette.hoverTextColor, opacity };
        }
        if (stateName === 'pressed') {
            return { color: palette.pressedColor, textColor: palette.pressedTextColor, opacity };
        }
        if (stateName === 'selected') {
            return { color: palette.selectedColor, textColor: palette.selectedTextColor, opacity };
        }
        if (stateName === 'disabled') {
            return { color: palette.disabledColor, textColor: palette.disabledTextColor, opacity };
        }

        return { color: palette.color, textColor: palette.textColor, opacity };
    },

    update: function (oldData) {
        const data = this.data;
        if (data.image && oldData.image !== data.image) {
            this.updateImage(data);
        }

        if (oldData.label !== data.label || oldData.autosize !== data.autosize) {
            if (this.text) {
                this.text.setAttribute('value', data.label);
                if (data.autosize) {
                    this.adjustButtonSize();
                } else {
                    this.adjustTextScale(data);
                }

                if (this.data.contentRotation) {
                    this.text.setAttribute('rotation', `0 0 ${this.data.contentRotation}`);
                }
            }
        }
        if (
            oldData.type !== data.type ||
            oldData.width !== data.width ||
            oldData.height !== data.height ||
            oldData.depth !== data.depth ||
            oldData.radius !== data.radius ||
            oldData.cornerstyle !== data.cornerstyle
        ) {
            this.updateGeometry(data);
        }

        if (
            oldData.colorScheme !== data.colorScheme ||
            oldData.selected !== data.selected ||
            oldData.disabled !== data.disabled
        ) {
            this.updateThemeAppearance(this.activeThemeMode);
        }
    },

    createButton: function () {
        const data = this.data;
        this.updateGeometry(data);

        if (data.type === 'image-text') {
            this.updateImage(data);
            this.createText(data);
        } else if (data.image) {
            this.updateImage(data);
        } else {
            this.createText(data);
        }
        this.el.setAttribute('data-raycastable', '');
    },
    createText: function (data) {
        this.text = document.createElement('a-text');
        this.text.setAttribute('value', data.label);
        this.text.setAttribute('color', '#fff');
        this.text.setAttribute('font-size', '0.2');
        this.text.setAttribute('scale', '0.25 0.25 0.25');
        this.text.setAttribute('align', 'center');
        this.text.setAttribute('anchor', 'center');
        this.text.setAttribute('baseline', 'center');
        this.text.setAttribute('depth-offset', '1');
        const zPos = data.textZp || this.calculateTextZPosition(data);
        this.text.setAttribute('position', `0 0 ${zPos}`);

        if (data.autosize) {
            this.text.setAttribute('scale', '1 1 1');
        } else {
            this.adjustTextScale(data);
        }
        this.el.appendChild(this.text);

        this.text.addEventListener('loaded', () => {
            if (data.autosize) {
                this.adjustButtonSize();
            } else {
                this.adjustTextScale(data);
            }
        });

        if (data.type === 'image-text') {
            this.text.setAttribute('position', `${data.width * 0.05} 0 ${zPos}`);
        }

        if (data.isAutoRotationContent) {
            this.text.classList.add('billboard');
            this.text.setAttribute('position', '0 0 0.5');
        }
    },

    updateImage: function (data) {
        if (this.imageEl) {
            this.el.removeChild(this.imageEl);
        }
        this.imageEl = document.createElement('a-plane');

        const isSvg = data.image.toLowerCase().endsWith('.svg');
        let src = data.image;
        if (isSvg) {
            if (svgAssetMap.has(data.image)) {
                src = svgAssetMap.get(data.image);
            } else {
                let existingAssetId = null;
                const assets = document.querySelector('a-assets');
                if (assets) {
                    if (data.image.includes('building.svg')) {
                        const buildingAsset = assets.querySelector('#building-icon');
                        if (buildingAsset) {
                            existingAssetId = 'building-icon';
                        }
                    } else if (data.image.includes('bar-chart-line.svg')) {
                        const barChartAsset = assets.querySelector('#bar-chart-line-icon');
                        if (barChartAsset) {
                            existingAssetId = 'bar-chart-line-icon';
                        }
                    }
                }

                if (existingAssetId) {
                    svgAssetMap.set(data.image, `#${existingAssetId}`);
                    src = `#${existingAssetId}`;
                } else {
                    const assetId = `svg-${Math.random().toString(36).substr(2)}`;
                    let assets = document.querySelector('a-assets');
                    if (!assets) {
                        assets = document.createElement('a-assets');
                        document.querySelector('a-scene').appendChild(assets);
                    }
                    const imgAsset = document.createElement('img');
                    imgAsset.setAttribute('id', assetId);
                    imgAsset.setAttribute('src', data.image);
                    assets.appendChild(imgAsset);
                    svgAssetMap.set(data.image, `#${assetId}`);
                    src = `#${assetId}`;
                }
            }
        }
        const width = data.type === 'image-text' ? data.height * 0.5 : data.width * 0.9;
        const height = data.type === 'image-text' ? data.height * 0.5 : data.height * 0.9;

        const iconColor = this.currentContentColor || (this.currentThemeColors ? this.currentThemeColors.textColor : '#FFFFFF');

        this.imageEl.setAttribute('geometry', {
            primitive: 'plane',
            width,
            height
        });
        this.imageEl.setAttribute('material', {
            shader: 'flat',
            src: src,
            color: iconColor,
            transparent: true,
            alphaTest: 0.1,
            side: 'double',
            opacity: 1,
            crossOrigin: 'anonymous'
        });

        this.imageEl.addEventListener('loaded', () => {
            const color = this.currentContentColor || (this.currentThemeColors ? this.currentThemeColors.textColor : '#FFFFFF');
            this.imageEl.setAttribute('material', 'color', color);
        });

        const zPos = this.calculateImageZPosition(data);
        if (data.type === 'image-text') {
            this.imageEl.setAttribute('position', `${-data.width * 0.35} 0 ${zPos}`);
        } else {
            this.imageEl.setAttribute('position', `0 0 ${zPos}`);
        }

        if (this.data.contentRotation) {
            this.imageEl.setAttribute('rotation', `0 0 ${this.data.contentRotation}`);
        }

        if (this.data.isAutoRotationContent) {
            this.imageEl.classList.add('billboard');
            this.imageEl.setAttribute('position', '0 0 0.03');
        }

        this.imageEl.setAttribute('scale', '1 1 1');

        this.el.appendChild(this.imageEl);
        this.updateGeometry(data);
    },

    updateGeometry: function (data) {
        if (data.type === 'rounded-box' || data.type === 'image-text') {
            this.el.setAttribute('rounded-box', {
                width: data.width,
                height: data.height,
                depth: data.depth,
                radius: data.radius,
                color: '#000000',
                opacity: 1,
                cornerstyle: data.cornerstyle
            });
        } else {
            this.el.setAttribute('geometry', {
                primitive: data.type === 'box' ? 'box' : 'plane',
                width: data.width,
                height: data.height,
                depth: data.type === 'box' ? data.depth : undefined
            });
            this.el.setAttribute('material', {
                shader: 'standard',
                color: '#000000',
                opacity: 1,
                transparent: true,
                side: 'double'
            });
        }
        this.el.setAttribute('data-raycastable', '');
        this.applyVisualState();
    },

    adjustButtonSize: function () {
        if (this.data.image) return;
        setTimeout(() => {
            const data = this.data;
            const textScale = 0.8;
            const textValue = data.label;

            const charWidth = 0.11 * textScale;
            const estimatedTextWidth = textValue.length * charWidth;
            const textHeight = 0.8 * textScale;

            const paddingX = 0.2;
            const newWidth = estimatedTextWidth + paddingX * 2;
            const newHeight = textHeight;

            if (data.type === 'rounded-box') {
                this.el.setAttribute('rounded-box', {
                    width: newWidth,
                    height: newHeight,
                    depth: data.depth,
                    radius: data.radius,
                    cornerstyle: data.cornerstyle
                });
            } else if (data.type === 'box') {
                this.el.setAttribute('geometry', {
                    primitive: 'box',
                    width: newWidth,
                    height: newHeight,
                    depth: data.depth
                });
            } else {
                this.el.setAttribute('geometry', {
                    primitive: 'plane',
                    width: newWidth,
                    height: newHeight
                });
            }

            const zPos = this.calculateTextZPosition(data);
            this.text.setAttribute('position', `0 0 ${zPos}`);
            this.applyVisualState();
        }, 100);
    },

    adjustTextScale: function (data) {
        if (!this.text) return;

        if (this.data.preferredFontSize) {
            const scale = this.data.preferredFontSize * 5;
            this.text.setAttribute('scale', `${scale} ${scale} ${scale}`);

            return;
        }

        const textValue = data.label;
        const charWidth = data.width > 1 && textValue.length > 15 ? 0.095 : (data.width > 1 ? 0.085 : 0.07);
        const estimatedTextWidth = textValue.length * charWidth;
        const textHeight = 0.15;
        const padding = 0.075;
        const widthScale = (data.width - padding) / estimatedTextWidth;
        const heightScale = (data.height - padding) / textHeight;
        const textScale = Math.min(widthScale, heightScale, 1.0) * 0.9;
        this.text.setAttribute('scale', `${textScale} ${textScale} ${textScale}`);
        this.text.setAttribute('font-size', 0.24 * Math.min(textScale, 1.0));
    },

    calculateImageZPosition: function (data) {
        if (data.type === 'plane') {
            return 0.001;
        } else if (data.type === 'box' || (data.type === 'rounded-box' && data.cornerstyle === 'ext')) {
            return data.depth / 2 + 0.001;
        } else {
            return data.depth / 2 + data.radius / 2 + 0.001;
        }
    },

    calculateTextZPosition: function (data) {
        if (data.type === 'plane') {
            return 0.005;
        } else if (data.type === 'box' || (data.type === 'rounded-box' && data.cornerstyle === 'ext')) {
            return data.depth + 0.01;
        } else {
            return data.depth / 2 + data.radius / 2 + 0.01;
        }
    },

    bindEvents: function () {
        this.el.addEventListener('mouseenter', () => {
            if (!this.data.disabled && !this.data.selected && this.data.hoverAble) {
                this.isHovered = true;
                this.applyVisualState('hover');
                if (this.data.hoverScale !== 1) {
                    const s = this.initialScale;
                    const f = this.data.hoverScale;
                    this.el.setAttribute('scale', `${s.x * f} ${s.y * f} ${s.z * f}`);
                }
            }
        });

        this.el.addEventListener('mouseleave', () => {
            if (!this.data.disabled && !this.data.selected && this.data.hoverAble) {
                this.isHovered = false;
                this.isPressed = false;
                this.applyVisualState();
                const s = this.initialScale;
                this.el.setAttribute('scale', `${s.x} ${s.y} ${s.z}`);
            }
        });

        this.el.addEventListener('mousedown', () => {
            if (!this.data.disabled && !this.data.selected) {
                this.isPressed = true;
                this.applyVisualState('pressed');
                if (this.data.clickScale !== 1) {
                    const s = this.initialScale;
                    const f = this.data.clickScale;
                    this.el.setAttribute('scale', `${s.x * f} ${s.y * f} ${s.z * f}`);
                }
            }
        });

        this.el.addEventListener('mouseup', () => {
            if (!this.data.disabled && !this.data.selected) {
                this.isPressed = false;
                this.applyVisualState(this.isHovered ? 'hover' : undefined);
                const s = this.initialScale;
                this.el.setAttribute('scale', `${s.x} ${s.y} ${s.z}`);
            }
        });

        this.el.addEventListener('click', () => {
            if (!this.data.disabled) {
                if (this.data.isSelectable) {
                    this.el.setAttribute('ui-button', 'selected', true);
                } else {
                    this.applyVisualState('pressed');
                    if (this.data.clickScale !== 1) {
                        const s = this.initialScale;
                        const f = this.data.clickScale;
                        this.el.setAttribute('scale', `${s.x * f} ${s.y * f} ${s.z * f}`);
                    }
                    setTimeout(() => {
                        this.applyVisualState();
                        const s = this.initialScale;
                        this.el.setAttribute('scale', `${s.x} ${s.y} ${s.z}`);
                    }, 100);
                }
            }
        });
    },

    setColor: function (color, opacity) {
        const colorValue = (color && color.getStyle) ? color.getStyle() : color;
        const alpha = typeof opacity === 'number' ? opacity : 1;
        const data = this.data;
        if (data.type === 'rounded-box' || data.type === 'image-text') {
            this.el.setAttribute('rounded-box', 'color', colorValue || '#222222');
            this.el.setAttribute('rounded-box', 'opacity', alpha);
        } else {
            this.el.setAttribute('material', 'color', colorValue || '#222222');
            this.el.setAttribute('material', 'opacity', alpha);
            this.el.setAttribute('material', 'transparent', alpha < 1);
        }

        if (this.el.object3D.children[0] &&
            this.el.object3D.children[0].material &&
            this.el.object3D.children[0].material.color) {
            this.el.object3D.children[0].material.color.set(colorValue || '#222222');
            this.el.object3D.children[0].material.opacity = alpha;
            this.el.object3D.children[0].material.transparent = alpha < 1;
            this.el.object3D.children[0].material.needsUpdate = true;
        }
    },

    setTextColor: function (color) {
        if (this.text && color) {
            this.text.setAttribute('color', color);
        }

        if (this.imageEl && color) {
            this.imageEl.setAttribute('material', 'color', color);
        }
    },

    applyVisualState: function (transientState) {
        const state = this.getEffectiveStateName(transientState);
        const visual = this.getVisualForState(state);

        this.currentVisualState = state;
        this.currentContentColor = visual.textColor;
        this.baseColor = new THREE.Color(this.currentThemeColors.color);
        this.currentHoverColor = new THREE.Color(this.currentThemeColors.hoverColor);
        this.currentClickColor = new THREE.Color(this.currentThemeColors.pressedColor);

        this.setColor(visual.color, visual.opacity);
        this.setTextColor(visual.textColor);
    },

    onThemeChanged: function (e) {
        this.updateThemeAppearance(e.detail.themeMode);
    },

    updateThemeAppearance: function (themeMode) {
        this.activeThemeMode = themeMode;
        this.currentThemeColors = this.resolveThemeColors(this.activeThemeMode);

        this.updateGeometry(this.data);
        this.applyVisualState();
    }
});